import Vue from 'vue';
import stickybits from 'stickybits';
import Cookies from 'js-cookie';

require('./bootstrap/globals');
require('./components');

new Vue({
	el: '#app',
	data() {
		return {
			mobileMenu: false,
			currentMenu: '',
			scroll: 0,
			scrolled: false
		};
	},
	methods: {
		handleScroll() {
			this.scroll = window.pageYOffset;
			if (this.scroll > 3 && !this.scrolled) {
				this.scrolled = true;
			}
		},
		closePopup(once) {
			this.$refs.popup.remove();

			if (once) {
				Cookies.set('hamletpop', 1, { expires: 7 });
			}
		},
		openMenu() {
			this.mobileMenu = !this.mobileMenu;
		},
		addStyle(styles) {
			/* Create style element */
			var css = document.createElement('style');
			css.type = 'text/css';

			if (css.styleSheet) css.styleSheet.cssText = styles;
			else css.appendChild(document.createTextNode(styles));

			/* Append style to the head element */
			document.getElementsByTagName('head')[0].appendChild(css);
		}
	},
	delimiters: ['${', '}'],
	mounted() {
		this.$nextTick(() => {
			stickybits('.sticky-item', { useStickyClasses: true, useFixed: true });
			const styles = `.max-h-mobile { max-height: ${window.outerHeight}px; }`;
			this.addStyle(styles);
			document.querySelector('body').classList.remove('overflow-y-hidden');
			setTimeout(() => {
				this.scrolled = true;
			}, 1200);
		});
	}
});
